export default "__VITE_ASSET__CuDydVcL__"